import { Log } from '../../shared/log';
import { Injectable } from '@angular/core';

const log = Log.getLogger('WindowRef');

@Injectable()
export class WindowRef {

  constructor() { }

  get nativeWindow(): any {
    // return the global native browser window object
    return window;
  }

  get locationHash(): any {
    return this.nativeWindow.location.hash;
  }

  get location(): any {
    return this.nativeWindow.location;
  }

  public removeTokenURLHistory(redirectPath?: string): void {
    // Getting current URL without hash by constructing URL from location properties
    // instead of using something like location.href.split('#') to avoid potential XXS exploits

    const baseURL = this.location.protocol + '//' + this.location.host;
    const path = redirectPath ? redirectPath : (this.location.pathname ? this.location.pathname : '');
    const redirectURL = baseURL + path;

    // Using location.replace() instead of location.hash = '' to remove the hash from URL
    // to prevent user from going back to the URL contains #access_token
    this.nativeWindow.location.replace(redirectURL);
  }

  public navigateTo(href: string): void {
    this.nativeWindow.location.href = href;
  }
}



// WEBPACK FOOTER //
// ./app/services/window-ref/window.ref.ts